import React, { useCallback, useContext, useEffect, useState } from 'react';
import Draggable from 'react-draggable';
import { Toast, ToastBody, ToastHeader } from 'reactstrap';
import Table from '../../../Common/Table';
import { useTranslation } from '@hooks';
import { useAssetListFloorDetailColumns } from '@util/grid/column';
import moment from 'moment';
import { RealTimeLocationStatusContext } from '../index';

const FloorDetailPopup = ({ modal, toggleModal, widgetRef, mapRef }) => {
    const t = useTranslation('RealTimeLocationStatus');
    const { geofenceInfo, realTimeLog, categoryList } = useContext(RealTimeLocationStatusContext);
    const [itemList, setItemList] = useState({ pageSize: 4, totalPage: 3, rows: [] });

    const [position, setPosition] = useState({
        x: 0,
        y: 0,
    });
    const [popupSize, setPopupSize] = useState({
        x: 0,
        y: 0,
    });

    const popupRef = useCallback(node => {
        if (node !== null) {
            const { width, height } = node.getBoundingClientRect();

            setPopupSize({
                width,
                height,
            });
        }
    }, []);

    useEffect(() => {
        const widgetPosition = getWidgetPosition();

        const x = (widgetPosition.width - popupSize.width) / 2 - 20;
        const y = widgetPosition.height / 2 - widgetPosition.height / 4 - 100;
        setPosition({
            x: Math.ceil(x),
            y: Math.ceil(y),
        });
    }, [popupSize]);

    useEffect(() => {
        const targetList =
            realTimeLog &&
            realTimeLog.data.map(target => {
                const { target: targetInfo, floorInOutState } = target;
                const category = categoryList.find(v => targetInfo.categoryCode === v.categoryCode);
                return {
                    targetId: targetInfo.targetId,
                    targetName: targetInfo.targetName,
                    categoryName: category && category.categoryName,
                    entryTime: moment.unix(floorInOutState.inTime).format('YYYY-MM-DD HH:mm:ss'),
                };
            });
        setItemList({ ...itemList, rows: targetList });
    }, [realTimeLog]);

    const getPosition = (el, position = { top: 0, left: 0 }) => {
        if (el) {
            position.top += el.offsetTop;
            position.left += el.offsetLeft;
            getPosition(el.offsetParent, position);
        }
        return position;
    };

    const getWidgetPosition = () => {
        const widgetPosition = { x: 0, y: 0 };

        if (widgetRef.current) {
            const widget = widgetRef.current;

            const { offsetWidth: width, offsetHeight: height } = widget;

            widgetPosition.width = width;
            widgetPosition.height = height;
        }
        return widgetPosition;
    };

    return (
        <Draggable
            key={JSON.stringify(position)}
            bounds=".leaflet-container"
            defaultPosition={position}
            onStop={() => mapRef.current.leafletElement.dragging.enable()}
            onStart={() => mapRef.current.leafletElement.dragging.disable()}
        >
            <Toast isOpen={modal} className={'popup-open floorDetail bg-depth-3'} innerRef={popupRef}>
                <ToastHeader className={'bg-depth-4'} toggle={toggleModal}>
                    {t('Information of the Selected Floor')}
                </ToastHeader>
                <ToastBody className={'bg-depth-4'}>
                    <div className={'pnt-txt txt-dot txt-bold s-9 mb-1'}>{`${t('Number of Geofence')} : ${
                        geofenceInfo && geofenceInfo.length ? geofenceInfo.length : 0
                    }`}</div>
                    <div className={'pnt-txt txt-dot txt-bold s-9'}>{`${t(
                        'Total Number of Detected Items on the Selected Floor',
                    )} : ${realTimeLog.count ? realTimeLog.count : 0}`}</div>
                    <Table
                        columns={useAssetListFloorDetailColumns()}
                        data={{
                            rows: itemList.rows,
                            pageSize: 5,
                            totalPage: itemList.rows.length % 5 === 0 ? itemList.rows / 5 : itemList.rows / 5 + 1,
                            totalCount: itemList.rows.length,
                        }}
                        manualPagination={false}
                        autoResetPage={false}
                    />
                </ToastBody>
            </Toast>
        </Draggable>
    );
};
export default FloorDetailPopup;
